import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=1205fbb2"
import script from "./EditPage.vue?vue&type=script&lang=js"
export * from "./EditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1205fbb2')) {
      api.createRecord('1205fbb2', component.options)
    } else {
      api.reload('1205fbb2', component.options)
    }
    module.hot.accept("./EditPage.vue?vue&type=template&id=1205fbb2", function () {
      api.rerender('1205fbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/clients/layouts/EditPage.vue"
export default component.exports